import Swal from "sweetalert2";
import "@/assets/scss/base/sweetalert2.scss";

const options_swal = {
  showCloseButton: false,
  cancelButtonColor: "#963833",
  confirmButtonColor: "#35656f",
};

export default {
  install(app, options) {
    const swal = (opts = {}) => {
      return Swal.fire({
        ...options_swal,
        ...options,
        ...opts,
        ...{
          // position:'top-start'
        },
      });
    };

    const preguntar = (opts = {}, next = () => {}, error = () => {}) => {
      swal({
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        // position:'top-start',
        ...opts,
      }).then(({ isConfirmed, isDenied, isDismissed }) => {
        if (isConfirmed) next();
        if (isDenied) error();
        if (isDismissed) error();
      });
    };

    app.provide("swal", swal);
    app.provide("preguntar", preguntar);
    app.config.globalProperties.swal = swal;
    window.preguntar = preguntar;
    return (window.swal = swal);
  },
};
